export default __webpack_public_path__ + "static/media/checkmark@2x.bbfe59b2.png";